export enum SystemTimeCategoryGroupDescriptionEnums {
  ALL,
  TRANSFERRED_TO_PAYROLL,
  ABSENCE,
  LATE_ENTRY_EARLY_EXIT,
  PREMIUMS,
  ABSENCE_REQUEST_TCG,
  WTS_TIME_CATEGORY_GROUP,
  OBSOLETE_BILL_148_REGULAR_WAGES_NUMERATOR,
  OBSOLETE_BILL_148_LEAVE__OR_VACATION,
  OBSOLETE_BILL148_REGULAR_WAGES_DENOMINATOR,
  DASHBOARD_HOURS_BY_CATEGORY,
  DASHBOARD_HOURS_BY_JOB,
  PARTIAL_ABSENCES,
  BANKABLE,
  TIME_BANK,
  BOLT_PERIOD_SIGNOFF_METRIC,
  BOLT_PERIOD_SIGNOFF_DETAILS,
}
